import { Box, Container } from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import { FormularioPesquisa } from './components/FormularioPesquisa'
import { ResultadoConsulta } from './components/ResultadoConsulta'
import { useConsultarReferenciaLayout } from './hooks/useConsultarReferenciaLayout'
import './styles.css'

export const ConsultarReferenciaLayout = () => {
  const { dados, loading, consultarReferencias } = useConsultarReferenciaLayout()

  const handleSubmit = (data) => {
    const { codigo_produto } = data
    consultarReferencias(codigo_produto)
  }

  return (
    <Box>
      <HeadingPages name="Consultar Referência Layout" />

      <Container maxW="container.xl" py={6}>
        <FormularioPesquisa onSubmit={handleSubmit} isLoading={loading} />

        <ResultadoConsulta dados={dados} isLoading={loading} />
      </Container>
    </Box>
  )
}
